import React from "react";
import StripePricingTable from "../components/StripePricingTable";
import { Link } from "react-router-dom/cjs/react-router-dom";

export default function Produtos() {
  return (
    <section>
      <div id="exlusao" className="fix mtop-20">
        .
      </div>
      <div id="exlusao" className="fix mtop-20">
        .
      </div>
      <div className="text-center p-3">
        <p>
          O uso ou compra dos produtos implica na sua concordância com o{" "}
          <Link to="/Termo">Termo de Compromisso</Link>.
        </p>
      </div>
      <div className="container">
        <h1>Confira nossos produtos</h1>
        <StripePricingTable />
        <hr />

        <div className="text-center">
          <a
            href="https://billing.stripe.com/p/login/cNi9ATfSH8TK1gB3PIfQI00"
            className="btn btn-primary my-4"
          >
            Portal do Cliente
          </a>
        </div>
        <hr />
        <div className="text-center p-3">
          <p>
            O uso ou compra dos produtos implica na sua concordância com o{" "}
            <Link to="/Termo">Termo de Compromisso</Link>.
          </p>
        </div>
      </div>
    </section>
  );
}
